import { isLocalhost } from 'utils/is-localhost';
import { isNitroEnvironment, isOrbitsEnvironment } from 'utils/is-nitro-env';

declare global {
  interface Window {
    Chargebee: any;
  }
}

/**
 * Patch fix to load the correct CB site name based on ENV
 * TODO: to be handled in webpack config/ github actions supporting staging ENV.
 */
const getChargebeeSiteName = (): string => {
  if (isLocalhost() || isOrbitsEnvironment()) {
    return 'sairamrl2-test';
  }
  if (isNitroEnvironment()) {
    return 'rocketlane-test';
  }

  return 'rocketlane';
};

/**
 * TODO: configure chargebee site name based on ENV
 */
const getInstance = () =>
  window.Chargebee.init({ site: getChargebeeSiteName() });

export const loadChargebeeJS = (): Promise<any> =>
  new Promise((resolve) => {
    const existingScript = document.getElementById('chargebee');

    if (existingScript) {
      resolve(getInstance());

      return;
    }
    const script = document.createElement('script');

    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.id = 'chargebee';
    script.onload = () => resolve(getInstance());

    document.head.appendChild(script);
  });
